import type * as React from 'react';
import {useState} from 'react';
import AuthHandler from '../../components/Auth/AuthHandler';
import SubmitPhotoDialog from './SubmitPhotoDialog';

type Props = {
    open: boolean;
    onClose: () => void;
};

const SubmitPhotoController: React.FC<Props> = ({open, onClose}: Props) => {
    const [authenticated, setAuthenticated] = useState(false);

    return (
        <>
            <SubmitPhotoDialog open={open && authenticated} onClose={onClose} />

            <AuthHandler
                requireAuth={open}
                requiredTokenLifetime={600}
                onClose={onClose}
                onAuth={() => {
                    setAuthenticated(true);
                }}
                onExpire={() => {
                    setAuthenticated(false);
                    onClose();
                }}
            />
        </>
    );
};

export default SubmitPhotoController;
